module.exports = __webpack_public_path__ + "a6bb81a01051a3d33558ce788801c28b.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/Help/screenshots/navbar-bottom-unauthenticated.PNG
// module id = 1055
// module chunks = 0